import { getIconPath } from '../../utils/modelIconMapper';

const PRESERVE_BRAND_COLOR_ICON_KEYS = new Set(['birefnet', 'rodin', 'meshy']);

const ModelIcon = ({
  iconKey,
  size = 'md',
  tone = 'muted',
  className = '',
  style,
}) => {
  const classes = [
    'ui-model-icon',
    size ? `ui-model-icon--${size}` : null,
    tone ? `ui-model-icon--${tone}` : null,
    PRESERVE_BRAND_COLOR_ICON_KEYS.has(iconKey) ? 'ui-model-icon--brand' : null,
    className,
  ].filter(Boolean).join(' ');

  return (
    <img
      src={getIconPath(iconKey)}
      alt=""
      aria-hidden="true"
      className={classes}
      style={style}
    />
  );
};

export default ModelIcon;
